import React from 'react';
import Button from '@mui/material/Button';

/**
 * English Teacher admin branded button — mirror of the website's
 * AppButton so the same variant names produce the same visuals across
 * the admin, portal, and public site.
 *
 * Variants: primary | secondary | tertiary | cta (see theme.js).
 * Prefer this over ad-hoc `<Button sx={{...}}>` for new code.
 */
const AppButton = ({ variant = 'primary', children, ...rest }) => (
    <Button variant={variant} {...rest}>
        {children}
    </Button>
);

export default AppButton;
